var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBench(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bada00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2187,
    stopColor: "#b6d600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4501,
    stopColor: "#acc900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6873,
    stopColor: "#9ab400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    stopColor: "#829700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798c00"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.606,
    x2: 250.209,
    xlinkHref: "#lg1",
    y1: 355.682,
    y2: 456.512
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.592,
    x2: 176.623,
    xlinkHref: "#lg1",
    y1: 394.694,
    y2: 442.143
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.581,
    x2: 369.454,
    xlinkHref: "#lg1",
    y1: 382.547,
    y2: 455.421
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a57c52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#a26c4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.408,
    x2: 162.17,
    xlinkHref: "#lg2",
    y1: 371.51,
    y2: 371.51
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.03,
    x2: 418.791,
    xlinkHref: "#lg2",
    y1: 371.51,
    y2: 371.51
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.028,
    x2: 130.79,
    xlinkHref: "#lg2",
    y1: 184.579,
    y2: 184.579
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.41,
    x2: 450.171,
    xlinkHref: "#lg2",
    y1: 184.579,
    y2: 184.579
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.356,
    x2: 266.115,
    xlinkHref: "#lg3",
    y1: 93.834,
    y2: 206.388
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    stopColor: "#f67150",
    stopOpacity: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(-1 0 0 1 510 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 219.704,
    x2: 223.771,
    xlinkHref: "#lg4",
    y1: 170.661,
    y2: 111.177
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(-1 0 0 1 510 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 349.553,
    x2: 349.553,
    xlinkHref: "#lg4",
    y1: 143.956,
    y2: 85.654
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.488,
    x2: 69.442,
    xlinkHref: "#lg3",
    y1: 166.877,
    y2: 113.83
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.356,
    x2: 70.326,
    xlinkHref: "#lg4",
    y1: 172.745,
    y2: 114.714
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.336,
    x2: 117.236,
    xlinkHref: "#lg2",
    y1: 133.724,
    y2: 161.625
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.869,
    x2: 388.823,
    xlinkHref: "#lg3",
    y1: 166.877,
    y2: 113.83
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.25,
    x2: 397.047,
    xlinkHref: "#lg4",
    y1: 166.257,
    y2: 122.054
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.717,
    x2: 436.618,
    xlinkHref: "#lg2",
    y1: 133.724,
    y2: 161.625
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.356,
    x2: 266.115,
    xlinkHref: "#lg3",
    y1: 185.348,
    y2: 297.902
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.704,
    x2: 223.771,
    xlinkHref: "#lg4",
    y1: 262.175,
    y2: 202.691
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.227,
    x2: 367.227,
    xlinkHref: "#lg4",
    y1: 235.47,
    y2: 177.168
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.488,
    x2: 69.442,
    xlinkHref: "#lg3",
    y1: 258.391,
    y2: 205.344
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.356,
    x2: 70.326,
    xlinkHref: "#lg4",
    y1: 264.259,
    y2: 206.229
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.336,
    x2: 117.236,
    xlinkHref: "#lg2",
    y1: 225.238,
    y2: 253.139
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.869,
    x2: 388.823,
    xlinkHref: "#lg3",
    y1: 258.391,
    y2: 205.344
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.25,
    x2: 397.047,
    xlinkHref: "#lg4",
    y1: 257.771,
    y2: 213.568
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.717,
    x2: 436.618,
    xlinkHref: "#lg2",
    y1: 225.238,
    y2: 253.139
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 425.516,
    x2: 469.012,
    xlinkHref: "#lg1",
    y1: 360.558,
    y2: 454.666
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.77,
    x2: 400.332,
    xlinkHref: "#lg1",
    y1: 396.969,
    y2: 441.255
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.148,
    x2: 131.807,
    xlinkHref: "#lg1",
    y1: 369.982,
    y2: 462.642
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.963,
    x2: 93.725,
    xlinkHref: "#lg2",
    y1: 371.51,
    y2: 371.51
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.475,
    x2: 487.236,
    xlinkHref: "#lg2",
    y1: 371.51,
    y2: 371.51
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.487,
    x2: 265.925,
    xlinkHref: "#lg3",
    y1: 265.047,
    y2: 375.673
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 320.198,
    y2: 342.661
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m158.04 428.824h112.898c12.806 0 23.188-10.382 23.188-23.188v-10.834c0-37.579-30.464-68.043-68.043-68.043-37.579 0-68.043 30.464-68.043 68.043z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.689 428.824h62.177c7.053 0 12.77-5.717 12.77-12.77v-5.966c0-20.696-16.778-37.474-37.474-37.474-20.696 0-37.474 16.777-37.474 37.474v18.736z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m364.79 428.824h-82.13c-9.316 0-16.868-7.552-16.868-16.868v-7.881c0-27.337 22.161-49.499 49.499-49.499 27.337 0 49.499 22.161 49.499 49.499z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m126.689 428.824c10.611 0 19.214-8.602 19.214-19.214v-95.415h-38.428v95.415c.001 10.612 8.603 19.214 19.214 19.214z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.311 428.824c10.611 0 19.214-8.602 19.214-19.214v-95.415h-38.428v95.415c0 10.612 8.602 19.214 19.214 19.214z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m114.523 287.982h-38.427v-192.677c0-7.804 6.326-14.13 14.13-14.13h10.168c7.804 0 14.13 6.326 14.13 14.13v192.677z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.904 287.982h-38.427v-192.677c0-7.804 6.326-14.13 14.13-14.13h10.168c7.804 0 14.13 6.326 14.13 14.13v192.677z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m439.395 179.352h-368.79c-12.363 0-22.385-10.022-22.385-22.385v-34.538c0-12.363 10.022-22.385 22.385-22.385h368.79c12.363 0 22.385 10.022 22.385 22.385v34.538c.001 12.363-10.022 22.385-22.385 22.385z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.164 162.936h150.756c8.9 0 17.436-3.536 23.73-9.829 6.294-6.294 14.83-9.829 23.73-9.829h106.401v13.689c0 12.363-10.022 22.386-22.386 22.386h-321.862c10.511-10.512 24.767-16.417 39.631-16.417z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.439 148.023h-210.22v-25.594c0-.976.069-1.935.19-2.877h210.029c7.862 0 14.236 6.373 14.236 14.236 0 7.861-6.373 14.235-14.235 14.235z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 95.309,
    cy: 139.698,
    fill: "url(#SVGID_11_)",
    r: 24.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.659 127.77c-3.282-3.67-8.038-5.994-13.349-5.994-9.898 0-17.922 8.024-17.922 17.922 0 5.311 2.324 10.068 5.994 13.35l26.304 26.304h50.554z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.309,
    cy: 139.698,
    fill: "url(#SVGID_13_)",
    r: 17.922
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 414.691,
    cy: 139.698,
    fill: "url(#SVGID_14_)",
    r: 24.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.39 161.12-33.35-33.35c-3.282-3.67-8.038-5.994-13.349-5.994-9.898 0-17.922 8.024-17.922 17.922 0 5.311 2.324 10.068 5.994 13.35l26.304 26.304h10.328c10.943 0 20.047-7.854 21.995-18.232z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.691,
    cy: 139.698,
    fill: "url(#SVGID_16_)",
    r: 17.922
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m439.395 270.866h-368.79c-12.363 0-22.385-10.022-22.385-22.385v-34.538c0-12.363 10.022-22.385 22.385-22.385h368.79c12.363 0 22.385 10.022 22.385 22.385v34.538c.001 12.363-10.022 22.385-22.385 22.385z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.836 254.45h-150.756c-8.9 0-17.436-3.536-23.73-9.829-6.294-6.294-14.83-9.829-23.73-9.829h-106.401v13.689c0 12.363 10.022 22.386 22.386 22.386h321.862c-10.511-10.512-24.767-16.417-39.631-16.417z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.91 239.537h174.871v-25.594c0-.976-.069-1.935-.19-2.877h-174.681c-7.862 0-14.236 6.373-14.236 14.236 0 7.861 6.374 14.235 14.236 14.235z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 95.309,
    cy: 231.212,
    fill: "url(#SVGID_20_)",
    r: 24.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.659 219.284c-3.282-3.67-8.038-5.994-13.349-5.994-9.898 0-17.922 8.024-17.922 17.922 0 5.311 2.324 10.068 5.994 13.35l26.304 26.304h50.554z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.309,
    cy: 231.212,
    fill: "url(#SVGID_22_)",
    r: 17.922
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 414.691,
    cy: 231.212,
    fill: "url(#SVGID_23_)",
    r: 24.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.39 252.634-33.35-33.35c-3.282-3.67-8.038-5.994-13.349-5.994-9.898 0-17.922 8.024-17.922 17.922 0 5.311 2.324 10.068 5.994 13.35l26.304 26.304h10.328c10.943 0 20.047-7.854 21.995-18.232z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.691,
    cy: 231.212,
    fill: "url(#SVGID_25_)",
    r: 17.922
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m382.988 428.824h105.37c11.952 0 21.642-9.689 21.642-21.642v-10.111c0-35.073-28.433-63.506-63.506-63.506-35.073 0-63.506 28.433-63.506 63.506z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.728 428.824h58.031c6.583 0 11.919-5.336 11.919-11.919v-5.569c0-19.316-15.659-34.975-34.975-34.975-19.316 0-34.975 15.659-34.975 34.975z",
    fill: "url(#SVGID_27_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m125.876 428.824h-104.428c-11.845 0-21.448-9.602-21.448-21.448v-10.021c0-34.76 28.178-62.938 62.938-62.938 34.76 0 62.938 28.178 62.938 62.938z",
    fill: "url(#SVGID_28_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m58.244 428.824c10.611 0 19.214-8.602 19.214-19.214v-95.415h-38.427v95.415c0 10.612 8.602 19.214 19.213 19.214z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.756 428.824c10.611 0 19.214-8.602 19.214-19.214v-95.415h-38.428v95.415c0 10.612 8.602 19.214 19.214 19.214z",
    fill: "url(#SVGID_30_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m477.685 342.251h-445.37c-9.828 0-17.794-7.967-17.794-17.794v-28.662c0-9.828 7.967-17.794 17.794-17.794h445.369c9.828 0 17.794 7.967 17.794 17.794v28.662c.001 9.827-7.966 17.794-17.793 17.794z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.521 300.879v23.578c0 9.827 7.967 17.794 17.794 17.794h445.369c9.828 0 17.794-7.967 17.794-17.794v-23.578z",
    fill: "url(#SVGID_32_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBench);
export default __webpack_public_path__ + "static/media/icon-bench.8492ae40d64ff154ccdc265f25ab0ece.svg";
export { ForwardRef as ReactComponent };